(function () {
    function SidebarController(
        $scope,
        $timeout,
        $state,
        $transitions,
        $q,
        $uibModal,
        $urlMatcherFactory,
        PermissionService,
        CampaignsService,
        DashboardConfig,
        ErrorService,
    ) {
        const self = this;

        self.ready = false;

        self.userOrContextChange = function () {
            if (!self.ready) {
                return
            }
            $scope.showSideBar = true;
            self.user = PermissionService.user || {};
            $scope.firstName = self.user.FirstName;
            const shouldDenyAccess = !self.user
                && !self.user.hasBrandContext
                && !self.user.hasCallCenterContext
                && !self.user.hasStoreContext;
            if (shouldDenyAccess) {
                $timeout(PermissionService.navigateToAccessDenied);
                return;
            }

            $scope.shouldShowBrandContext = self.user.hasBrandContext && self.brands.length > 0;
            $scope.shouldShowCallCenterContext = self.user.hasCallCenterContext && self.callCenters.length > 0;
            $scope.shouldShowStoreContext = self.user.hasStoreContext && self.stores.length > 0;
            $scope.showContext = !self.user.hasSingleContext;
            let userContextSelected = false;

            self.userContext = new Dashboard.Models.Permissions.RoleContext();
            if (PermissionService.userContext) {
                self.userContext = PermissionService.userContext;
                $scope.ContextType = self.userContext.ContextType;
                userContextSelected = true;
            } else {
                if ($scope.shouldShowBrandContext) {
                    $scope.ContextType = Dashboard.ContextTypes.BrandContext;
                } else if ($scope.shouldShowCallCenterContext) {
                    $scope.ContextType = Dashboard.ContextTypes.CallCenterContext;
                } else if ($scope.shouldShowStoreContext) {
                    $scope.ContextType = Dashboard.ContextTypes.StoreContext;
                }
                const templateUrl = "components/context/contextpicker.42e218b4.html";
                const modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl,
                    controller: "ContextPickerModalController",
                    size: "lg",
                    backdrop: "static",
                    resolve: {
                        brands: function () {
                            return self.brands;
                        },
                        callCenters: function () {
                            return self.callCenters;
                        },
                        stores: function () {
                            return self.stores;
                        },
                        showBrandContext: function () {
                            return $scope.shouldShowBrandContext;
                        },
                        showCallCenterContext: function () {
                            return $scope.shouldShowCallCenterContext;
                        },
                        showStoreContext: function () {
                            return $scope.shouldShowStoreContext;
                        }
                    }
                });
                modalInstance.result.then(function () {
                    self.userOrContextChange();
                })
            }
            self.contextTypeChanged(!userContextSelected);
        };


        self.contextTypeChanged = function (resetValues) {
            if (resetValues) {
                self.userContext.BrandId = undefined;
                self.userContext.BrandName = undefined;
                self.userContext.CallCenterId = undefined;
                self.userContext.CallCenterName = undefined;
                self.userContext.StoreId = undefined;
                self.userContext.StoreName = undefined;
            }
            $scope.contextInstance = {};
            switch ($scope.ContextType) {
                case Dashboard.ContextTypes.BrandContext:
                    $scope.contextInstances = self.brands;
                    $scope.contextInstance.Id = self.userContext.BrandId;
                    break;
                case Dashboard.ContextTypes.CallCenterContext:
                    $scope.contextInstances = self.callCenters;
                    $scope.contextInstance.Id = self.userContext.CallCenterId;
                    break;
                case Dashboard.ContextTypes.StoreContext:
                    $scope.contextInstances = self.stores;
                    $scope.contextInstance.Id = self.userContext.StoreId;
                    break;
            }
            const first = ($scope.contextInstances || [])[0];
            const clone = first ? { Id: first.Id, Name: first.Name } : undefined;
            $scope.contextInstance = ($scope.contextInstance.Id)
                ? $scope.contextInstance : clone;
        };

        $scope.changeContextType = function (contextType) {
            $scope.ContextType = contextType;
            self.contextTypeChanged(true);
        };

        /**
         * @return {boolean}
         */
        $scope.IsSubMenuActive = function (subMenuItems) {
            if (typeof subMenuItems === "undefined") return false;
            if (subMenuItems.length === 0) return false;
            return _.some(subMenuItems, function (item) {
                return item.state === $scope.currentState;
            })
        };

        $scope.$watch("contextInstance.Id", function (newValue) {
            if ($scope.ContextType && newValue) {
                self.userContext.ContextType = $scope.ContextType;
                $timeout(function () {
                    self.contextInstanceChanged(newValue);

                    $scope.reportsURL = PermissionService.doesUserHavePermission(
                        Dashboard.Models.Lookups.Permissions.ReportsAccess)
                        ? DashboardConfig.ReportioUrl
                        : "";
                });
            }
        });

        self.contextInstanceChanged = function (id) {
            switch ($scope.ContextType) {
                case Dashboard.ContextTypes.BrandContext:
                    self.brandChanged(id);
                    break;
                case Dashboard.ContextTypes.CallCenterContext:
                    self.callCenterChanged(id);
                    break;
                case Dashboard.ContextTypes.StoreContext:
                    self.storeChanged(id);
                    break;
            }
            $timeout(self.pickContext)
        };

        self.brandChanged = function (id) {
            const selectedBrand = _.findWhere(self.brands, { Id: id });
            if (selectedBrand) {
                self.userContext.BrandId = selectedBrand.Id;
                self.userContext.BrandName = selectedBrand.Name;
            }
        };

        self.callCenterChanged = function (id) {
            const selectedCallCenter = _.findWhere(self.callCenters, { Id: id });
            if (selectedCallCenter) {
                self.userContext.CallCenterId = selectedCallCenter.Id;
                self.userContext.CallCenterName = selectedCallCenter.Name;
            }
        };

        self.storeChanged = function (id) {
            const selectedStore = _.findWhere(self.stores, { Id: id });
            if (selectedStore) {
                self.userContext.StoreId = selectedStore.Id;
                self.userContext.StoreName = selectedStore.Name;
            }
        };

        self.pickContext = function () {
            PermissionService.userContext = self.userContext;
            PermissionService.notifyContextChanged();
        };

        self.initialiseContextSelection = function () {
            if (self.initialisingContext) return;
            self.initialisingContext = true;
            $scope.ContextTypes = [
                {
                    value: Dashboard.ContextTypes.BrandContext,
                    label: "Brand"
                },
                {
                    value: Dashboard.ContextTypes.CallCenterContext,
                    label: "Switchboard"
                },
                {
                    value: Dashboard.ContextTypes.StoreContext,
                    label: "Restaurant"
                }
            ];
            $q.all([
                PermissionService.getUserBrands(),
                PermissionService.getUserCallCenters(),
                PermissionService.getUserStores()
            ])
                .then(function (results) {
                    self.brands = results[0] || [];
                    self.callCenters = results[1] || [];
                    self.stores = results[2] || [];
                    self.ready = true;
                    self.userOrContextChange();
                    self.initialisingContext = false;
                });
        };

        self.initialise = function () {
            $scope.showSideBar = false;
            $scope.logoutURL = DashboardConfig.LogoutURL;
            $scope.supportUrl = DashboardConfig.SupportUrl;
            $scope.$on(Dashboard.Events.UserContextNotSet, self.initialiseContextSelection);
            $scope.$on(Dashboard.Events.UserContextChanged, self.loadMenu);
            $scope.$on(Dashboard.Events.CampaignUpdated, self.loadCampaignStatusCount);
            PermissionService.$initialised.then(function () {
                self.initialiseContextSelection();
            });
            $transitions.onSuccess({}, function () {
                self.userOrContextChange();
                $scope.parentState = Dashboard.helpers.stateHelper.getParentState($state.current.name);
                $scope.currentState = $state.current.name;
            });

        };

        $scope.$watch(function () {
            return $state.$current.name
        }, function (newVal) {
            $scope.parentState = Dashboard.helpers.stateHelper.getParentState(newVal);
            $scope.currentState = newVal;

            if (!$scope.currentState
                || !$scope.parentState
                || !$scope.menuItems) {
                return;
            }

            let parentId = "";
            $scope.menuItems.forEach((menuItem) => {
                menuItem.subMenuItems.forEach((subMenuItem) => {
                    if (subMenuItem.state === newVal) {
                        parentId = menuItem.value;
                    }
                });
            });

            const menuSubItems = $(".nav .nav-second-level");
            if (!parentId) {
                if (!/^app\.(store|brand)campaigns/.test(newVal)) {
                    menuSubItems.collapse("hide");
                }
                return;
            }

            const menuSubItemsArray = Array.from(menuSubItems);
            menuSubItemsArray.forEach(menuSubItem => {
                var menuSubItemId = $(menuSubItem).attr("id")
                if (parentId !== menuSubItemId) {
                    $(menuSubItem).collapse("hide");
                }
            });

            $("[id='" + parentId + "']").collapse("show");
        });

        self.loadSubMenuForItem = function (item, routeParams) {
            const items = [];
            const subMenuItems = item.subMenuItems || [];
            subMenuItems.forEach(function (subItem) {
                const canAdd = !Array.isArray(subItem.permissions) ||
                    PermissionService.doesUserHaveAnyPermission(subItem.permissions)
                if (canAdd) {
                    items.push({
                        value: subItem.subMenuVal,
                        state: subItem.stateConfig.state,
                        url: $state.href(subItem.stateConfig.state, routeParams)
                    });
                }
            });
            return items;
        };

        self.loadMenu = function () {
            $scope.menuItems = [];
            const menuItems = [];
            let currentIndex = 0;
            _.each(Dashboard.menuStates.groups, function (group) {
                const menuGroup = new Dashboard.Models.MenuGroup().initialiseMenuGroup(group);
                if (menuGroup.isGroupStateCurrent($state.current.name)) {
                    currentIndex = menuItems.length;
                }
                const item = {
                    value: menuGroup.menuVal,
                    iconClass: menuGroup.iconClass,
                    url: "",
                    subMenuItems: []
                };

                const userHasPermission = menuGroup.permissions.reduce(
                    (acc, cur) =>
                        acc || PermissionService.doesUserHavePermissionForContext(
                            cur, self.userContext
                        ),
                    false);

                if (userHasPermission) {
                    if (self.userContext.BrandId && _.size(menuGroup.brandItems) > 0) {
                        const brandItem = menuGroup.returnDefaultMenuItem(Dashboard.ContextTypes.BrandContext);
                        item.subMenuItems = self.loadSubMenuForItem(brandItem, { brandId: self.userContext.BrandId });
                        item.url = (brandItem.subMenuItems)
                            ? "#"
                            : $state.href(brandItem.stateConfig.state, { brandId: self.userContext.BrandId });

                        item.state = brandItem.stateConfig
                            ? brandItem.stateConfig.state
                            : Dashboard.helpers.stateHelper.getParentState(item.subMenuItems[0].state);

                        menuItems.push(item);
                    } else if (self.userContext.CallCenterId && _.size(menuGroup.callCenterItems) > 0) {
                        const callCenterItem = menuGroup.returnDefaultMenuItem(Dashboard.ContextTypes.CallCenterContext);
                        item.subMenuItems =
                            self.loadSubMenuForItem(callCenterItem, { CallCenterId: self.userContext.CallCenterId });

                        item.url = (callCenterItem.subMenuItems)
                            ? "#"
                            : $state.href(callCenterItem.stateConfig.state, { callCenterId: self.userContext.CallCenterId });

                        item.state = callCenterItem.stateConfig
                            ? callCenterItem.stateConfig.state
                            : Dashboard.helpers.stateHelper.getParentState(item.subMenuItems[0].state);

                        menuItems.push(item);
                    } else if (self.userContext.StoreId && _.size(menuGroup.storeItems) > 0) {
                        const storeItem = menuGroup.returnDefaultMenuItem(Dashboard.ContextTypes.StoreContext);
                        item.subMenuItems =
                            self.loadSubMenuForItem(storeItem, { storeId: self.userContext.StoreId });

                        item.url = (storeItem.subMenuItems)
                            ? "#"
                            : $state.href(storeItem.stateConfig.state, { storeId: self.userContext.StoreId });

                        item.state = storeItem.stateConfig
                            ? storeItem.stateConfig.state
                            : Dashboard.helpers.stateHelper.getParentState(item.subMenuItems[0].state);
                        menuItems.push(item);
                    }
                }

            });

            $scope.menuItems = menuItems;
            self.loadCampaignStatusCount();
            self.initialNavigation();
            $timeout(function () {
                try {
                    $("#menu").metisMenu("dispose");
                } catch (e) {
                } finally {
                    $("#menu").metisMenu({ preventDefault: false });
                }
            });
        };

        self.loadCampaignStatusCount = function () {
            const campaignsMenuItem = _.findWhere($scope.menuItems, { value: "Campaigns" });
            if (campaignsMenuItem) {
                CampaignsService.getCampaignStatusCount(self.userContext.StoreId, self.userContext.BrandId)
                    .then(function (result) {
                        const scheduledCampaignsItem = _.find(campaignsMenuItem.subMenuItems, function (item) {
                            return item.state.indexOf(".scheduledcampaigns") !== -1;
                        });
                        const activeCampaignsItem = _.find(campaignsMenuItem.subMenuItems, function (item) {
                            return item.state.indexOf(".currentcampaigns") !== -1;
                        });
                        scheduledCampaignsItem.count = result.data.Scheduled;
                        activeCampaignsItem.count = result.data.Active;
                    }, function error(result) {
                        ErrorService.showError("An error occurred while loading the campaign status counts", result);
                    });
            }
        };

        $scope.navigateToHomePage = function () {
            window.location = window.location.href.split("#")[0];
        }

        self.initialise();
    }

    /**
     * This is still part of the modernising of this whole project. The big part of it is
     * rewriting components from functions to classes which because of the framework, makes so much sense.
     *
     * Instead of fully refactoring the controller, it's safer to just move the bit of code being modified
     * at that time and test the crap out of it, as it would take forever (pretty much) to try and write
     * tests for everything in the controller, that in any given time has nothing to do with the task any developer
     * would be looking at.
     *
     * The goal is for this comment not to exist, and that will be when pretty much all moving parts of this
     * component are safely guarded by a unit test.
     */
    class SidebarComponent extends SidebarController {
        constructor(
            $scope,
            $timeout,
            $state,
            $transitions,
            $q,
            $uibModal,
            $urlMatcherFactory,
            PermissionService,
            CampaignsService,
            DashboardConfig,
            ErrorService,
        ) {
            super(
                $scope,
                $timeout,
                $state,
                $transitions,
                $q,
                $uibModal,
                $urlMatcherFactory,
                PermissionService,
                CampaignsService,
                DashboardConfig,
                ErrorService,
            );
            this._permissionService = PermissionService;
            this._state = $state;
        }

        initialNavigation() {
            if (this._state.current.name === 'app.home') {
                return;
            }

            const userHasPermissionForCurrentState = this.doesUserHavePermissionForCurrentState()
            if (!userHasPermissionForCurrentState) {
                return this._state.go("app.home")
            }
            const {
                StoreId: contextStoreId,
                BrandId: contextBrandId,
                CallCenterId: contextCallCenterId
            } = this.userContext;

            const params = {
                ...this._state.params,
                storeId: contextStoreId,
                brandId: contextBrandId,
                callCenterId: contextCallCenterId
            };

            return this._state.go(this._state.current.name, params)
        }

        doesUserHavePermissionForCurrentState() {
            const permissions = Dashboard.getPermissionsForState(this._state.current.name);
            return this._permissionService.doesUserHaveAnyPermission(permissions)
        }

        shouldUpdateStateParameters() {
            const params = this.useStateParams();
            const contextStoreId = Number(this.userContext.StoreId);
            const contextBrandId = Number(this.userContext.BrandId);
            const contextCallCenterId = Number(this.userContext.CallCenterId);
            return contextStoreId !== params.stateParamsStoreId
                && contextBrandId !== params.stateParamsBrandId
                && contextCallCenterId !== params.stateParamsCallCenterId;
        }

        useStateParams() {
            const stateParamsStoreId = Number(this._state.params.storeId);
            const stateParamsBrandId = Number(this._state.params.brandId);
            const stateParamsCallCenterId = Number(this._state.params.callCenterId);
            return {
                stateParamsBrandId,
                stateParamsStoreId,
                stateParamsCallCenterId,
            };
        }
    }

    angular
        .module("dashboard")
        .component("sidebar",
            {
                templateUrl: "components/sidebar/sidebar.2b123db6.html",
                bindings: {},
                controller: [
                    "$scope",
                    "$timeout",
                    "$state",
                    "$transitions",
                    "$q",
                    "$uibModal",
                    "$urlMatcherFactory",
                    "PermissionService",
                    "CampaignsService",
                    "DashboardConfig",
                    "ErrorService",
                    SidebarComponent
                ]
            });
})();
